<template>
  <div class="scroll-box enable-scroll">
    <div class="box">
      <div v-if="test_advice_type == '需要關注'">
        <MainHalfTitle text="立即關注腦部健康"></MainHalfTitle>
        <MainDescribe text="謝謝您參加「中大網上認知測試」，你的測試結果為需要關注。"></MainDescribe>
        <div v-if="follow_up_is_wish == true">
          <MainDescribe text="以下機構將會進一步與您聯絡："></MainDescribe>
          <MainDescribe :text="'機構名稱：' + info_ngo.name"></MainDescribe>
          <MainDescribe :text="'地址：' + info_ngo.address"></MainDescribe>
          <MainDescribe :text="'電話：' + info_ngo.phone"></MainDescribe>
        </div>
        <br>
        <MainDescribe text="歡迎瀏覽賽馬會「智康健」腦退化檢測及社區支援計劃網站或腦退化症網上學習平台學習更多腦退化症知識。"></MainDescribe>
        <br>
        <MainDescribe text="賽馬會「智康健」腦退化檢測及社區支援計劃"></MainDescribe>
        <MainDescribe href="https://www.jccpa.org.hk/projects/dscs"></MainDescribe>
        <br>
        <MainDescribe text="腦退化症網上學習平台"></MainDescribe>
        <MainDescribe href="https://edu.jccpa.org.hk"></MainDescribe>
      </div>
      <div v-else>
        <MainHalfTitle text="腦部健康小貼士"></MainHalfTitle>
        <MainDescribe v-if="test_advice_type == '合格'" text="謝謝您參加「中大網上認知測試」，你的測試結果為合格。">
        </MainDescribe>
        <MainDescribe text="歡迎瀏覽賽馬會耆智園網站" href="https://www.jccpa.org.hk/about-dementia/brain-health-tips"
          text_2="學習更多健腦知識。"></MainDescribe>
        <br>
        <MainDescribe text="其他參考網站︰"></MainDescribe>
        <br>
        <MainDescribe text="賽馬會「智康健」腦退化檢測及社區支援計劃"></MainDescribe>
        <MainDescribe href="https://www.jccpa.org.hk/projects/dscs"></MainDescribe>
        <br>
        <MainDescribe text="腦退化症網上學習平台"></MainDescribe>
        <MainDescribe href="https://edu.jccpa.org.hk"></MainDescribe>
        <br>
        <MainDescribe text="周佩芳認知障礙預防研究中心"></MainDescribe>
        <MainDescribe href="https://cog.mect.cuhk.edu.hk"></MainDescribe>
      </div>
    </div>
  </div>

</template>

<script>
import MainHalfTitle from "@/components/common/MainHalfTitle";
import MainDescribe from "@/components/common/MainDescribe";
export default {
  name: "HomeHealthTips",
  components: {
    MainDescribe,
    MainHalfTitle
  },
  props: {
    data: { type: Object },
    info_ngo: { type: Object }
  },
  data() {
    return {
      test_advice_type: '',
      follow_up_is_wish: false,
    }
  },
  mounted() {
    if (this.data.no_result === undefined) {
      this.test_advice_type = this.data.advice_type;
      if (this.data.follow_up !== null) {
        this.follow_up_is_wish = this.data.follow_up.is_join === 0 ? false : true;
      }
    }
  },
  methods: {
    goBack: function () {
      this.$emit('showUserInfo')
    }
  }
}
</script>

<style scoped>
.box {
  width: 100%;
  padding: 0 2vh;
}
</style>
